'use client';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
const EcoCreditsWinIn: any = dynamic(() => import('elem/compCommon/EcoCreditsWin/EcoCreditsWinIn'), { ssr: false });
export default function EcoCreditsWinEnterA() {
    const [isOpenA, setIsOpenA] = useState(false);

    // 关闭
    const closeHandle = () => {
        setIsOpenA(false);
        EcoDesignEventsBus.emit('widgets-EcoCreditsWin-close-1');
    };

    useEffect(() => {
        EcoDesignEventsBus.on('widgets-EcoCreditsWin-open', () => {
            setIsOpenA(true);
        });
        EcoDesignEventsBus.on('widgets-EcoCreditsWin-close-2', () => {
            setIsOpenA(false);
        });
    }, []);
    return <>{isOpenA && <EcoCreditsWinIn closeHandle={closeHandle} />}</>;
}
